import { Component, OnInit, Input, Inject } from '@angular/core';
import { VideoService } from '../../../services/video.service';
import { MDBModalRef } from 'angular-bootstrap-md';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {
  

    cmeQuizItem: any;

  questionsList : [];
  questionsListBackup : [];
  currentQuestionIndex = 0;
  currentQuestion : any;
  
  showAnswers : boolean = false;

  isTestFinished = false;

  closeDialog(){
    this.dialogRef.close();
  }
  
  constructor(private dialogRef:MatDialogRef<QuizComponent>, private videoService : VideoService,@Inject(MAT_DIALOG_DATA) public data: any) { 
      
        this.cmeQuizItem = data.cmeQuizItem;
        this.getCMEDetailsFromServer();
  }

  ngOnInit() {
    //getInstructorDetails
    //getVideoInstructor
  }

  
  ngOnChanges(){
    console.log("instructors"+JSON.stringify(this.cmeQuizItem));
    
  }

  getCMEDetailsFromServer(){
    var body = {"cme_id":""+this.cmeQuizItem._id.$oid};
    //var body = {"media_id":"58f139a090762600046ca3d1"};
    console.log("id"+JSON.stringify(body));
    
    this.videoService.getCMEQuestions(body).subscribe((resp : any) => {
      this.onVideoDetailsSuccess(resp);
      }, (err) => {
    // Unable to log in
          this.onVideoDetailsFetchError(err);    
    });

  }


  onVideoDetailsSuccess(resp){
      //console.log("On Instructor : "+JSON.stringify(resp));
      this.questionsList = resp;
      this.questionsListBackup = JSON.parse(JSON.stringify(resp));
      if(this.questionsList.length>0){
        this.currentQuestion = this.questionsList[this.currentQuestionIndex];
      }
      
  }

  onVideoDetailsFetchError(err){

  }

  nextQuestion(){
      if(this.currentQuestionIndex < this.questionsList.length-1){
        //console.log(this.currentQuestionIndex);
        this.currentQuestionIndex = this.currentQuestionIndex+1;
        this.currentQuestion = this.questionsList[this.currentQuestionIndex];
      }
  }


  previousQuestion(){
    if(this.currentQuestionIndex > 0){
      this.currentQuestionIndex = this.currentQuestionIndex-1;
      this.currentQuestion = this.questionsList[this.currentQuestionIndex];
    }
  }

  finishQuiz(){
     this.isTestFinished = true;
      this.showAnswers = true;
  }

  showResult(){
    this.isTestFinished = true;
     this.showAnswers = true;
 }

  isAnswerSelected(answerIndex){
      let isChecked  : boolean = false;
      if(this.currentQuestion.answerSelected != undefined){
        let option = this.currentQuestion.answers[answerIndex];
        if(this.currentQuestion.answerSelected.choice === option.choice){
          isChecked = true;
        }else{
          isChecked = false;
        }
      }else{
        isChecked = false;
      }
      //console.log(isChecked+"---"+answerIndex);
      return isChecked;
  }

  onOptionSelected(answerIndex : any){
      this.currentQuestion.answerSelected = this.currentQuestion.answers[answerIndex];
      //console.log("Answer Selected"+JSON.stringify(this.currentQuestion.answerSelected));
  }
  


  showResultSelected($event) {
      //console.log($event);
      this.showAnswers = false;
      this.currentQuestionIndex = $event;
      this.currentQuestion = this.questionsList[this.currentQuestionIndex];
  }

  quizRetake($event){
    //console.log(JSON.stringify(this.questionsListBackup));
    this.isTestFinished = false;
    this.showAnswers = false;
    this.questionsList = JSON.parse(JSON.stringify(this.questionsListBackup));
    this.currentQuestionIndex = 0;
    if(this.questionsList.length>0){
      this.currentQuestion = this.questionsList[this.currentQuestionIndex];
    }
  //  this.getCMEDetailsFromServer();
  }

  isCorrect(options : any){
    if(this.isTestFinished){
      if(options.choice === this.currentQuestion.attribute.answer_choice){
        return true;
      }else{
        return false;
      }
    }else{
      return false;
    }
  }


  showNext(){
   
    if(this.currentQuestionIndex < this.questionsList.length-1){
      return true;
    }
    return false;
  }

  showPrevious(){
    if(this.currentQuestionIndex == 0){
      return false;
    }
    return true;
  }


}
